// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"9be29b0285e6d0a6","5285":"b63f22bc9b03741b"}[chunkId] + ".css";
};